import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import { ScProgressiveGenericFormStepRendering } from '@innogy/shared/progressive-form/sitecore/models';
import type { ScFormFormGroupState } from '@innogy/sitecore-forms/models';
import { GenericFormService } from '@innogy/sitecore-forms/services';
import {
  GenericRichTextDirective,
  TextInterpolationService,
} from '@core/jss-utils';
import { FormGroupState } from 'ngrx-forms';
import {
  ProgressiveFormBodyDirective,
  ProgressiveFormStepWrapperComponent,
  ProgressiveFormSummaryDirective,
} from '@innogy/shared/progressive-form';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { GenericFormComponent } from '@innogy/sitecore-forms';
import { CSMaskDirective } from '@legacy/utils-contentsquare';

@Component({
  selector:
    'wl-progressive-generic-form[formState][rendering][trackStep][progressiveFormSelectorKey]',
  templateUrl: './progressive-generic-form.component.html',
  standalone: true,
  imports: [
    ProgressiveFormStepWrapperComponent,
    ProgressiveFormBodyDirective,
    RichTextWrapperComponent,
    GenericFormComponent,
    ProgressiveFormSummaryDirective,
    CSMaskDirective,
    GenericRichTextDirective,
  ],
})
export class ProgressiveGenericFormComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<ScFormFormGroupState>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: ScProgressiveGenericFormStepRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isReadonly = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() progressiveFormSelectorKey!: string;

  @Output()
  formSubmitted = new EventEmitter();

  submitForm(formIsValid: boolean) {
    if (formIsValid) {
      this.formSubmitted.emit();
    }
  }

  get interpolatedSummary() {
    const { Form: form } = this.rendering.fields;
    const { interpolate } = this.interpolationService;
    const interpolationMapping =
      this.genericFormService.matchFieldNameAndSummaryValue(
        form,
        this.formState
      );
    return interpolate(form.fields.Summary, interpolationMapping, 'rich_text');
  }

  constructor(
    private readonly interpolationService: TextInterpolationService,
    private readonly genericFormService: GenericFormService
  ) {}
}
